module.exports = __webpack_public_path__ + "img/JAOC_POP_WhiteSauce_oval.c571dd71.png";